module.exports = __webpack_public_path__ + "media/images/computer-9f682133a6d1f343d5f2578bde3dcd1b.jpg";